package com.patronat.top.client.di

import com.patronat.top.client.data.location.ClientLocationSearchRepository
import com.patronat.top.client.data.location.MapTilerLocationRemoteDataSource
import com.patronat.top.client.data.profile.ClientProfileRemoteDataSource
import com.patronat.top.client.data.profile.ClientProfileRepository
import com.patronat.top.client.data.reviews.ClientReviewsRemoteDataSource
import com.patronat.top.client.data.reviews.ClientReviewsRepository
import com.patronat.top.client.domain.profile.GetClientProfileUseCase
import com.patronat.top.client.domain.profile.SubmitClientContactMessageUseCase
import com.patronat.top.client.domain.profile.UpdateClientProfileUseCase
import com.patronat.top.client.domain.profile.DeleteClientAccountUseCase
import com.patronat.top.client.data.venues.ClientVenuesRemoteDataSource
import com.patronat.top.client.data.venues.ClientVenuesRepository
import com.patronat.top.client.domain.location.ReverseClientLocationUseCase
import com.patronat.top.client.domain.location.SearchClientLocationsUseCase
import com.patronat.top.client.domain.reviews.CreateClientReviewUseCase
import com.patronat.top.client.domain.reviews.GetClientMyReviewsUseCase
import com.patronat.top.client.domain.reviews.GetClientReviewSummaryUseCase
import com.patronat.top.client.domain.reviews.GetClientVenueReviewsUseCase
import com.patronat.top.client.domain.reviews.ToggleClientReviewLikeUseCase
import com.patronat.top.client.domain.venues.GetClientVenueByIdUseCase
import com.patronat.top.client.domain.venues.GetClientVenueServiceSuggestionsUseCase
import com.patronat.top.client.domain.venues.GetClientSavedVenueIdsUseCase
import com.patronat.top.client.domain.venues.GetClientSavedVenuesUseCase
import com.patronat.top.client.domain.venues.GetClientVenuesUseCase
import com.patronat.top.client.domain.venues.ToggleClientSavedVenueUseCase
import com.patronat.top.client.domain.venues.UnsaveClientVenueUseCase
import com.patronat.top.client.location.ClientMapTilerConfiguration
import com.patronat.top.client.presentation.home.ClientHomeViewModel
import com.patronat.top.client.presentation.map.ClientMapViewModel
import com.patronat.top.client.presentation.profile.ClientProfileViewModel
import com.patronat.top.client.presentation.saved.ClientSavedViewModel
import io.ktor.client.HttpClient
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import org.koin.core.qualifier.named
import org.koin.dsl.module

val clientHomeModule = module {
    single(named("mapTilerHttpClient")) {
        HttpClient {
            install(ContentNegotiation) {
                json(Json {
                    ignoreUnknownKeys = true
                    isLenient = true
                })
            }
            install(HttpTimeout) {
                requestTimeoutMillis = 10_000
                connectTimeoutMillis = 10_000
                socketTimeoutMillis = 10_000
            }
        }
    }
    single {
        MapTilerLocationRemoteDataSource(
            httpClient = get(named("mapTilerHttpClient")),
            apiKey = ClientMapTilerConfiguration.API_KEY
        )
    }
    single { ClientLocationSearchRepository(remoteDataSource = get()) }
    factory { SearchClientLocationsUseCase(repository = get(), dispatcherProvider = get()) }
    factory { ReverseClientLocationUseCase(repository = get(), dispatcherProvider = get()) }
    single { ClientVenuesRemoteDataSource(httpClient = get()) }
    single { ClientVenuesRepository(remoteDataSource = get()) }
    factory { GetClientVenuesUseCase(repository = get(), dispatcherProvider = get()) }
    factory { GetClientVenueByIdUseCase(repository = get(), dispatcherProvider = get()) }
    factory { GetClientVenueServiceSuggestionsUseCase(repository = get(), dispatcherProvider = get()) }
    factory { GetClientSavedVenueIdsUseCase(repository = get(), dispatcherProvider = get()) }
    factory { GetClientSavedVenuesUseCase(repository = get(), dispatcherProvider = get()) }
    factory { ToggleClientSavedVenueUseCase(repository = get(), dispatcherProvider = get()) }
    factory { UnsaveClientVenueUseCase(repository = get(), dispatcherProvider = get()) }
    single { ClientReviewsRemoteDataSource(httpClient = get()) }
    single { ClientReviewsRepository(remoteDataSource = get()) }
    factory { CreateClientReviewUseCase(repository = get(), dispatcherProvider = get()) }
    factory { GetClientVenueReviewsUseCase(repository = get(), dispatcherProvider = get()) }
    factory { GetClientReviewSummaryUseCase(repository = get(), dispatcherProvider = get()) }
    factory { GetClientMyReviewsUseCase(repository = get(), dispatcherProvider = get()) }
    factory { ToggleClientReviewLikeUseCase(repository = get(), dispatcherProvider = get()) }
    single { ClientProfileRemoteDataSource(httpClient = get()) }
    single { ClientProfileRepository(remoteDataSource = get()) }
    factory { GetClientProfileUseCase(repository = get(), dispatcherProvider = get()) }
    factory { UpdateClientProfileUseCase(repository = get(), dispatcherProvider = get()) }
    factory { SubmitClientContactMessageUseCase(repository = get(), dispatcherProvider = get()) }
    factory { DeleteClientAccountUseCase(repository = get(), dispatcherProvider = get()) }
    factory {
        ClientHomeViewModel(
            alertController = get(),
            getClientVenuesUseCase = get(),
            getVenueByIdUseCase = get(),
            getServiceSuggestionsUseCase = get(),
            getSavedVenueIdsUseCase = get(),
            toggleSavedVenueUseCase = get(),
            createReviewUseCase = get(),
            getVenueReviewsUseCase = get(),
            getReviewSummaryUseCase = get(),
            toggleReviewLikeUseCase = get(),
            uploadImageUseCase = get(),
            tokenStorage = get(),
            locationProvider = get(),
            searchLocationsUseCase = get(),
            reverseLocationUseCase = get()
        )
    }
    factory {
        ClientMapViewModel(
            alertController = get(),
            getClientVenuesUseCase = get(),
            locationProvider = get()
        )
    }
    factory {
        ClientSavedViewModel(
            alertController = get(),
            getSavedVenuesUseCase = get(),
            unsaveVenueUseCase = get(),
            tokenStorage = get()
        )
    }
    factory {
        ClientProfileViewModel(
            alertController = get(),
            getProfileUseCase = get(),
            updateProfileUseCase = get(),
            getMyReviewsUseCase = get(),
            submitContactMessageUseCase = get(),
            deleteClientAccountUseCase = get(),
            uploadImageUseCase = get(),
            tokenStorage = get()
        )
    }
}
